export default {
  featuredExperiences: 'Tr\u1ea3i nghi\u1ec7m n\u1ed5i b\u1eadt',
  searchAllExperiences: 'T\u00ecm t\u1ea5t c\u1ea3 tr\u1ea3i nghi\u1ec7m',
  searchAll: 'T\u00ecm t\u1ea5t c\u1ea3',
  groupSize: 'S\u1ed1 l\u01b0\u1ee3ng nh\u00f3m',
  eventSize: 'Quy m\u00f4 s\u1ef1 ki\u1ec7n',
  upTo: 'T\u1ed1i \u0111a',
  whatWeDo: 'Ch\u00fang ta s\u1ebd l\u00e0m g\u00ec',
  hostedBy: 'T\u1ed5 ch\u1ee9c b\u1edfi',
  whatsIncluded: 'Bao g\u1ed3m nh\u1eefng g\u00ec',
  avail: 'T\u00ecnh tr\u1ea1ng',
  whereWeAre: 'Ch\u00fang ta s\u1ebd \u1edf \u0111\u00e2u',
  experienceCalendar: 'L\u1ecbch tr\u1ea3i nghi\u1ec7m',
  experienceCancelled: 'Tr\u1ea3i nghi\u1ec7m \u0111\u00e3 h\u1ee7y',
  experienceStartingPrice: 'T\u1eeb {{price}}',
  experienceTotalPrice: 'T\u1ed5ng {{price}}',
  at: 'l\u00fac',
  viewPrivateSessAvailability: 'Xem t\u00ecnh tr\u1ea1ng phi\u00ean ri\u00eang',
  selectDuration: 'Th\u1eddi l\u01b0\u1ee3ng',
  selectStartTime: 'Gi\u1edd b\u1eaft \u0111\u1ea7u',
  selectSession: 'Ch\u1ecdn phi\u00ean',
  sessionsCount: '{{count}} thời gian — chọn thời gian',
  noAvailability: 'Kh\u00f4ng c\u00f3 s\u1eb5n',
  select: 'Ch\u1ecdn',
  slotLeft: 'C\u00f2n {{remainSlots}} ch\u1ed7',
  slotsLeft: 'C\u00f2n {{remainSlots}} ch\u1ed7',
  spotsLeft: 'Còn {{count}}',
  spotsLeftAriaLabel: 'Còn {{count}} chỗ',
  bookExperience: '\u0110\u1eb7t tr\u1ea3i nghi\u1ec7m',
  book: '\u0110\u1eb7t',
  learnMore: 'T\u00ecm hi\u1ec3u th\u00eam',
  apply: '\u00c1p d\u1ee5ng',
  maxPartySizes:
    'T\u1ed1i \u0111a {{maxGroupSize}} ch\u1ed7 m\u1ed7i nh\u00f3m',
  maxPartySize: 'T\u1ed1i \u0111a {{maxGroupSize}} ch\u1ed7 m\u1ed7i nh\u00f3m',
  selectSessionValidation: 'Vui l\u00f2ng ch\u1ecdn phi\u00ean',
  selectParticipantValidation:
    'Vui l\u00f2ng ch\u1ecdn ng\u01b0\u1eddi tham gia',
  selectDateValidation: 'Vui l\u00f2ng ch\u1ecdn ng\u00e0y',
  reminders: 'Nh\u1eafc nh\u1edf',
  seeOtherDates: 'Xem ng\u00e0y kh\u00e1c',
  location: '\u0110\u1ecba \u0111i\u1ec3m',
  about: 'Gi\u1edbi thi\u1ec7u',
  allExperiences: 'Tất cả trải nghiệm',
  soldOut: 'H\u1ebft ch\u1ed7',
  addOns: 'Ti\u1ec7n \u00edch b\u1ed5 sung',
  reviews: '\u0110\u00e1nh gi\u00e1',
  reviewSingular: '\u0111\u00e1nh gi\u00e1',
  reviewPlural: '\u0111\u00e1nh gi\u00e1',
  dateOfExperience: 'Ng\u00e0y tr\u1ea3i nghi\u1ec7m',
  readLess: '\u0110\u1ecdc \u00edt h\u01a1n',
  readMore: '\u0110\u1ecdc th\u00eam',
  seeMore: 'Xem th\u00eam',
  details: 'Chi ti\u1ebft',
  durationHour: 'giờ',
  durationHours: 'giờ',
  durationMinutes: 'phút',
  theFollowingVideoDoesNotContainAnyAudio:
    'Video sau kh\u00f4ng ch\u1ee9a \u00e2m thanh',
  by: 'B\u1edfi',
  chooseATime: 'Chọn thời gian cho {{title}}',
  amenities: 'Ti\u1ec7n nghi',
  ticketSalesOpenIn: 'B\u00e1n v\u00e9 m\u1edf trong',
  ticketSalesOpen: 'B\u00e1n v\u00e9 m\u1edf',
  ticketSalesCloseIn: 'B\u00e1n v\u00e9 \u0111\u00f3ng trong',
  ticketSalesClose: 'B\u00e1n v\u00e9 \u0111\u00f3ng',
  ticketSalesClosed: '\u0110\u00e3 \u0111\u00f3ng b\u00e1n v\u00e9',
  comingSoon: 'S\u1eafp ra m\u1eaft',
  inPartnershipWith: 'H\u1ee3p t\u00e1c v\u1edbi',
  notFoundExperienceTitle:
    'Tr\u1ea3i nghi\u1ec7m n\u00e0y kh\u00f4ng c\u00f2n c\u00f3 s\u1eb5n',
  notFoundExperienceSubtitle:
    'N\u00f3 c\u00f3 th\u1ec3 \u0111\u00e3 b\u1ecb g\u1ee1 xu\u1ed1ng, ho\u1eb7c li\u00ean k\u1ebft kh\u00f4ng c\u00f2n h\u1ee3p l\u1ec7.',
  deadLinkRecoverySubtitle: 'Khám phá các trải nghiệm khác có thể đặt',
  viewAllExperiences: 'Xem t\u1ea5t c\u1ea3 tr\u1ea3i nghi\u1ec7m',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>\u0110\u0103ng nh\u1eadp v\u00e0o t\u00e0i kho\u1ea3n World of Hyatt \u0111\u1ec3 \u0111\u1eb7t tr\u1ea3i nghi\u1ec7m n\u00e0y v\u00e0 nh\u1eadn 5 \u0110i\u1ec3m C\u01a1 b\u1ea3n</strong> cho m\u1ed7i $1 USD \u0111\u1ee7 \u0111i\u1ec1u ki\u1ec7n chi ti\u00eau</p>',
      basePoints:
        '<p><strong>\u0110\u0103ng nh\u1eadp v\u00e0o t\u00e0i kho\u1ea3n World of Hyatt \u0111\u1ec3 \u0111\u1eb7t tr\u1ea3i nghi\u1ec7m n\u00e0y v\u00e0 nh\u1eadn 10 \u0110i\u1ec3m C\u01a1 b\u1ea3n</strong> cho m\u1ed7i $1 USD \u0111\u1ee7 \u0111i\u1ec1u ki\u1ec7n chi ti\u00eau</p>',
      additionalBonusPoints:
        '<p><strong>Nh\u1eadn th\u00eam 4 \u0110i\u1ec3m Th\u01b0\u1edfng</strong> cho m\u1ed7i $1 USD \u0111\u1ee7 \u0111i\u1ec1u ki\u1ec7n chi ti\u00eau khi b\u1ea1n \u0111\u1eb7t b\u1eb1ng Th\u1ebb T\u00edn D\u1ee5ng World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Nh\u1eadn th\u00eam \u0111\u1ebfn 30% \u0110i\u1ec3m Th\u01b0\u1edfng b\u1ed5 sung</strong> t\u00f9y thu\u1ed9c v\u00e0o h\u1ea1ng th\u00e0nh vi\u00ean c\u1ee7a b\u1ea1n</p>',
      payWithPoints:
        '<p><strong>Thanh to\u00e1n b\u1eb1ng \u0110i\u1ec3m</strong> khi \u0111\u1eb7t tr\u1ea3i nghi\u1ec7m n\u00e0y</p>',
    },
  },
};
